import { useState, type FormEvent } from 'react';
import { ErrorState, Loading } from '../../components/States';
import { useAdminActivationBatches, useAdminProducts, useCreateAdminActivationBatch } from '../../hooks/api-hooks';
import { formatDateTime } from '../../lib/format';

export function AdminActivationCodesPage() {
  const batches = useAdminActivationBatches();
  const courses = useAdminProducts('COURSE');
  const create = useCreateAdminActivationBatch();
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState('10');
  const [maxRedemptions, setMaxRedemptions] = useState('1');
  const [expiresAt, setExpiresAt] = useState('');
  const [courseIds, setCourseIds] = useState<string[]>([]);

  function toggleCourse(id: string) {
    setCourseIds((current) => current.includes(id) ? current.filter((item) => item !== id) : [...current, id]);
  }

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    create.mutate({
      name: name.trim(),
      quantity: Number(quantity),
      maxRedemptions: Number(maxRedemptions),
      expiresAt: expiresAt ? new Date(expiresAt).toISOString() : undefined,
      courseIds,
    }, { onSuccess: () => { setName(''); setCourseIds([]); } });
  }

  const copyCodes = async () => {
    if (create.data?.codes.length) await navigator.clipboard.writeText(create.data.codes.join('\n'));
  };

  return (
    <section className="admin-page">
      <header className="admin-page-header"><div><h1>Mã kích hoạt</h1><p>Tạo mã theo lô để cấp quyền một hoặc nhiều khóa học.</p></div></header>
      <details className="admin-create-panel" open={Boolean(create.data)}>
        <summary>Tạo lô mã mới</summary>
        <form className="admin-form" onSubmit={submit}>
          <div className="admin-form-grid">
            <label>Tên lô mã<input required value={name} onChange={(event) => setName(event.target.value)} placeholder="Workshop tháng 9" /></label>
            <label>Số lượng mã<input required min="1" max="1000" type="number" value={quantity} onChange={(event) => setQuantity(event.target.value)} /></label>
            <label>Số lượt dùng mỗi mã<input required min="1" type="number" value={maxRedemptions} onChange={(event) => setMaxRedemptions(event.target.value)} /></label>
            <label>Hạn sử dụng<input type="datetime-local" value={expiresAt} onChange={(event) => setExpiresAt(event.target.value)} /></label>
          </div>
          <fieldset className="admin-choice-list"><legend>Cấp quyền khóa học</legend>
            {courses.data?.map((course) => <label key={course.courseId}><input type="checkbox" checked={Boolean(course.courseId && courseIds.includes(course.courseId))} onChange={() => course.courseId && toggleCourse(course.courseId)} />{course.title}</label>)}
          </fieldset>
          {create.error && <ErrorState error={create.error} />}
          <button disabled={create.isPending || !courseIds.length}>{create.isPending ? 'Đang tạo…' : 'Tạo mã kích hoạt'}</button>
        </form>
        {create.data && <div className="activation-result" role="status">
          <div><strong>Mã chỉ hiển thị đầy đủ lần này</strong><p>Hãy sao chép và lưu ở nơi an toàn trước khi rời trang.</p></div>
          <button type="button" className="btn btn-small" onClick={() => void copyCodes()}>Sao chép tất cả</button>
          <pre>{create.data.codes.join('\n')}</pre>
        </div>}
      </details>

      {batches.isPending && <Loading label="Đang tải các lô mã…" />}
      {batches.error && <ErrorState error={batches.error} />}
      {batches.data && <div className="admin-table-wrap"><table className="admin-table">
        <thead><tr><th>Lô mã</th><th>Khóa học</th><th>Tổng mã</th><th>Còn dùng được</th><th>Lượt kích hoạt</th><th>Ngày tạo</th></tr></thead>
        <tbody>{batches.data.map((batch) => <tr key={batch.id}>
          <td><strong>{batch.name}</strong></td>
          <td><span className="admin-tags">{batch.courses.map((course) => <small key={course.id}>{course.title}</small>)}</span></td>
          <td>{batch.codeCount}</td><td>{batch.availableCount}</td><td>{batch.redemptionCount}</td><td>{formatDateTime(batch.createdAt)}</td>
        </tr>)}{!batches.data.length && <tr><td colSpan={6} className="admin-empty">Chưa có lô mã kích hoạt.</td></tr>}</tbody>
      </table></div>}
    </section>
  );
}
